<h2 class="bd-title">Entity Filter</h2>
@if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
}

<form #settingsForm="ngForm" id="settingsForm">
  @if (settings$ | async; as settings) {
  <div class="cs-row">
    <div class="cs-label-wrapper">
      <div id="allEntitiesEnabledLabel" class="cs-larger-text cs-bolder-text">Process all entities</div>
      <div id="allEntitiesEnabledSubLabel" class="cs-secondary-text">
        Specify if you want to have permissions automatically replicated for all new or existing Dynamics 365 entities. Otherwise, only the selected entities will have permissions replicated.
      </div>
    </div>
    <div class="custom-control custom-switch">
      <input
        role="switch"
        type="checkbox"
        class="custom-control-input"
        id="allEntitiesEnabled"
        name="allEntitiesEnabled"
        aria-labelledby="allEntitiesEnabledLabel"
        aria-describedby="allEntitiesEnabledSubLabel"
        [attr.aria-checked]="settings.entityConfiguration.allEntitiesEnabled"
        [(ngModel)]="settings.entityConfiguration.allEntitiesEnabled"
        (ngModelChange)="updateSettings(settings)"
        [disabled]="readonly$ | async"
      />
      <label class="custom-control-label" for="allEntitiesEnabled">{{ settings.entityConfiguration.allEntitiesEnabled ? "On" : "Off" }}</label>
    </div>
  </div>
  @if (!settings.entityConfiguration.allEntitiesEnabled) {
  <div>
    <div class="cs-secondary-text">Select which Dynamics 365 entities are going to have permissions replicated.</div>
    <div class="cs-padded-left-wrapper">
      <div class="custom-control custom-checkbox">
        <input
          role="checkbox"
          type="checkbox"
          class="custom-control-input"
          id="selectAll"
          name="selectAll"
          [disabled]="readonly$ | async"
          [checked]="allSelected"
          [attr.aria-checked]="allSelected"
          (change)="selectAll(settings)"
        />
        <label class="custom-control-label" for="selectAll">Select all</label>
      </div>
      @for (entity of entities; track entity) {
      <div class="custom-control custom-checkbox">
        <input
          role="checkbox"
          type="checkbox"
          class="custom-control-input"
          id="{{ entity.logicalName }}"
          name="{{ entity.logicalName }}"
          [attr.aria-checked]="inputChecked(settings, entity)"
          [checked]="inputChecked(settings, entity)"
          (change)="inputChanged(settings, entity)"
          [disabled]="readonly$ | async"
        />
        <label class="custom-control-label" for="{{ entity.logicalName }}">{{ entity.logicalName }}</label>
      </div>
      }
    </div>
  </div>
  } }
</form>
